module.exports = __webpack_public_path__ + "img/65.10.pH.35441ba2.png";